import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom'; // Importar useNavigate para redirigir
import Header from '../components/Header/Header'; // Importar el Header
import { Modal, Button, Form, Dropdown } from 'react-bootstrap'; // Importar los componentes de modal y form
import Swal from 'sweetalert2'; // Importar SweetAlert2
import '../styles/Usuario.css'; // Importar el CSS

const Usuario = () => {
  const [productos, setProductos] = useState([]); // Estado para almacenar la lista de productos
  const [productosname, setProductosName] = useState([]); // Estado para almacenar la lista de productos
  const [addition, setAddition] = useState(''); // Para manejar la adición
  const [documento, setDocumento] = useState('');
  const [proveedor, setProveedor] = useState('');
  const [subtraction, setSubtraction] = useState(''); // Para manejar la sustracción
  const [error, setError] = useState(''); // Estado para manejar errores
  const [showModal, setShowModal] = useState(false); // Estado para controlar la visibilidad del modal
  const [selectedProduct, setSelectedProduct] = useState(null); // Producto seleccionado para editar
  const [newQuantity, setNewQuantity] = useState(''); // Nueva cantidad editable
  const [role, setRole] = useState(0); // Estado para almacenar el rol del usuario
  const [empresa, setEmpresa] = useState(null); // Estado para almacenar la información de la empresa
  const [showReportModal, setShowReportModal] = useState(false);
  const [fechaInicio, setFechaInicio] = useState(''); // yyyy-mm-dd
  const [fechaFinal, setFechaFinal] = useState('');   // yyyy-mm-dd
  const [loadingReport, setLoadingReport] = useState(false);
  const [savingQuantity, setSavingQuantity] = useState(false);

  const navigate = useNavigate(); // Para redirigir a otras páginas

  // Obtener el productsIdList, companyId y role desde localStorage
  const productsIdList = localStorage.getItem('productsIdList');
  const companyId = localStorage.getItem('companyId');
  const userRole = localStorage.getItem('role'); // Obtener el rol del usuario
  const NameUser = localStorage.getItem('name');

  // Función para obtener la lista de productos
  const obtenerProductos = async () => {
    try {
      const response = await fetch(`https://api.maderasdelatlantico.com/api/Product/obtenerproductosgeneral?companyId=${companyId}`);
      
      if (!response.ok) {
        throw new Error('Error al obtener la lista de productos');
      }

      const data = await response.json();
      setProductos(data); // Guardar los productos obtenidos en el estado
    } catch (error) {
      setError(error.message);
    }
  };

  // Función para obtener la información de la empresa si el usuario tiene Role 1
  const obtenerEmpresa = async () => {
    try {
      const response = await fetch(`https://api.maderasdelatlantico.com/api/Company/obtenerempresasbyid?companyId=${companyId}`);
      
      if (!response.ok) {
        throw new Error('Error al obtener la información de la empresa');
      }

      const data = await response.json();
      setEmpresa(data); // Guardar la información de la empresa
    } catch (error) {
      setError(error.message);
    }
  };

  const obtenerProductosNombres = async () => {
    try {
      const response = await fetch(`https://api.maderasdelatlantico.com/api/Product/obtenerproductosnombres?companyId=${empresa.companyId}`);

      if (!response.ok) {
        throw new Error('Error al obtener los nombres de productos');
      }
      console.log(response)

      const data = await response.json();
      setProductosName(data); // Guardar los nombres de productos en el estado
    } catch (error) {
      setError(error.message);
    }
  };

  // useEffect para hacer las llamadas al API cuando se carga la página
  useEffect(() => {
    obtenerProductos();
    setRole(parseInt(userRole)); // Guardar el rol del usuario desde localStorage

    // Si el usuario tiene Role 1, obtener la información de la empresa
    if (parseInt(userRole) === 1) {
      obtenerEmpresa();
    }
  }, [userRole]);

  useEffect(() => {
      // Verificar si empresa está disponible antes de llamar a obtenerProductosNombres
      if (empresa) {
        obtenerProductosNombres();
      }
    }, [empresa]);

  const totalQuantity = useMemo(() => {
    return (productos || []).reduce((acc, p) => {
      const name = (p?.name ?? '').toString().toUpperCase();
      console.log(productos)
      // Si el producto contiene "TABLILLAS", no lo sumamos
      if (name.includes('IGPS') || name.includes('REGLAS')) return acc;

      return acc + (Number(p?.quantity) || 0);
    }, 0);
  }, [productos]);


  // Función para abrir el modal y seleccionar un producto
  const handleOpenModal = (producto) => {
    setSelectedProduct({ ...producto, productId: producto.productId || producto.id }); // Verificar si el producto tiene 'productId' o 'id'
    setNewQuantity(producto.quantity); // Inicializar la cantidad con el valor actual
    setShowModal(true); // Mostrar el modal
  };

  // Función para cerrar el modal
  const handleCloseModal = () => {
    setShowModal(false); // Cierra el modal
    setSelectedProduct(null); // Limpia el producto seleccionado
    setNewQuantity(''); // Reinicia la cantidad
    setSavingQuantity(false);
    setAddition(''); // Reinicia el valor de adición
    setSubtraction(''); // Reinicia el valor de sustracción
    setDocumento('');
    setProveedor('');
  };  

  const handleOpenReportModal = () => {
    setFechaInicio('');
    setFechaFinal('');
    setShowReportModal(true);
  };

  const handleCloseReportModal = () => {
    setShowReportModal(false);
    setFechaInicio('');
    setFechaFinal('');
    setLoadingReport(false);
  };

  const descargarReporteVentasExcel = async () => {
    try {
      if (!fechaInicio || !fechaFinal) {
        Swal.fire({ icon: 'warning', title: 'Fechas requeridas', text: 'Selecciona fecha inicio y fecha fin.' });
        return;
      }

      // Validación simple: inicio <= fin
      if (new Date(fechaInicio) > new Date(fechaFinal)) {
        Swal.fire({ icon: 'warning', title: 'Rango inválido', text: 'La fecha inicio no puede ser mayor que la fecha fin.' });
        return;
      }

      setLoadingReport(true);

      // Armamos la URL con query params
      const url = `https://api.maderasdelatlantico.com/api/Report/reporte-ventas?companyId=${companyId}&fechaInicio=${fechaInicio}&fechaFinal=${fechaFinal}`;

      const response = await fetch(url, {
        method: 'GET'
      });

      if (!response.ok) {
        const message = await response.text();
        throw new Error(message || 'Error al generar el reporte');
      }

      // Descargar como archivo
      const blob = await response.blob();

      // Intentar obtener filename desde header (Content-Disposition)
      const contentDisposition = response.headers.get('content-disposition');
      let fileName = `reporte-ventas_${fechaInicio}_a_${fechaFinal}.xlsx`;

      if (contentDisposition) {
        const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i);
        if (match && match[1]) fileName = decodeURIComponent(match[1]);
      }

      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);

      Swal.fire({ icon: 'success', title: 'Reporte generado', showConfirmButton: false, timer: 1500 });
      handleCloseReportModal();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Error', text: err.message || 'Ocurrió un error' });
    } finally {
      setLoadingReport(false);
    }
  };

  // Función para guardar la cantidad modificada
  const handleSaveQuantity = async () => {
    if (savingQuantity) return;

    if (!selectedProduct || (!addition && !subtraction)) {
      setError("Debe ingresar una adición o sustracción para modificar la cantidad");
      return;
    }
  
    // Calcula la nueva cantidad aplicando la adición y la sustracción
    setSavingQuantity(true);

    let updatedQuantity = parseInt(newQuantity, 10) || 0;
    let totalOperation = 0;
  
    if (addition) {
      updatedQuantity += parseInt(addition, 10); // Sumar la cantidad ingresada
      totalOperation += parseInt(addition, 10);
    }
  
    if (subtraction) {
      updatedQuantity -= parseInt(subtraction, 10); // Restar la cantidad ingresada
      totalOperation -= parseInt(subtraction, 10);
    }
  
    if (updatedQuantity < 0) {
      setError("La cantidad resultante no puede ser negativa.");
      setSavingQuantity(false);
      return;
    }

    console.log(updatedQuantity)

    try {
      const url = `https://api.maderasdelatlantico.com/api/Product/modificarcantidad?cantidad=${updatedQuantity}&productId=${selectedProduct.productId}&companyId=${companyId}&listaProductos=${productsIdList}&documento=${documento}&proveedor=${proveedor}&user=${NameUser}&operacionCantidad=${totalOperation}`;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // Especificar el tipo de contenido
        }
      });

      if (!response.ok) {
        const message = await response.text();
        throw new Error(message || 'Error al modificar la cantidad del producto');
      }

      const updatedProducts = await response.json(); // Obtener la lista actualizada de productos
      setProductos(updatedProducts); // Actualizar el estado con la nueva lista de productos
      handleCloseModal()
      setShowModal(false); // Cerrar el modal

      Swal.fire({
        icon: 'success',
        title: 'Producto actualizado correctamente',
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      setError(error.message);
      setSavingQuantity(false);
    }
  };

  // Función para redirigir a la vista de orden de compra con validación de rol
  const handleCreateOrder = () => {
    if (role === 1 || role === 2) {
      navigate('/orden-compra'); // Redirige a OrdenCompra.js si el rol es 1 o 2
    } else if (role === 3) {
      navigate('/orden-compra-cliente'); // Redirige a OrdenCompraCliente.js si el rol es 3
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Acceso Denegado',
        text: 'No tienes permiso para acceder a esta página.',
        showConfirmButton: true
      });
    }
  };


  // Función para redirigir a la vista de envio
  const handleCreateShipment = () => {
    navigate('/envio', { state: { companyId } });
  };

  const handleUsuariosClick = () => {
    if (!empresa) {
      Swal.fire({
        icon: 'info',
        title: 'Cargando empresa',
        text: 'Espera un momento y vuelve a intentar.',
      });
      return;
    }
    navigate(`/usuario/${empresa.companyId}/usuarios`, { state: { empresa } });
  };

  const handleProductosClick = () => {
    // Redirigir a la vista de productos, pasando la información de la empresa
    navigate(`/empresa/${companyId}/productos`, { state: { empresa } });
  };

  return (
    <div>
      <Header />
      <div className="usuario-container">
        <div className="usuario-topbar">
          <h1 className="usuario-title">Productos Asignados</h1>
          <div className="total-chip" title="Suma de 'quantity' de todos los productos">
            Total de productos: {totalQuantity}
          </div>
        </div>
        
        {error && <p style={{ color: 'red' }}>Error: {error}</p>} {/* Mostrar error si ocurre */}

        {productos.length > 0 ? (
          <div className="productos-list-horizontal">
            {productos.map((producto, index) => (
              <div key={index} className="producto-item-horizontal" onClick={() => handleOpenModal(producto)}>
                <h3>{producto.name}</h3>
                <p><strong>Cantidad disponible:</strong> {producto.quantity}</p>
              </div>
            ))}
          </div>
        ) : (
          <p>No tienes productos asignados.</p>
        )}

        {/* Modal para Reportes */}
        <Modal show={showReportModal} onHide={handleCloseReportModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Reportes</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form>
              <Form.Group className="mb-3" controlId="fechaInicio">
                <Form.Label>Fecha inicio</Form.Label>
                <Form.Control
                  type="date"
                  value={fechaInicio}
                  onChange={(e) => setFechaInicio(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="fechaFinal">
                <Form.Label>Fecha fin</Form.Label>
                <Form.Control
                  type="date"
                  value={fechaFinal}
                  onChange={(e) => setFechaFinal(e.target.value)}
                />
              </Form.Group>

              <div style={{ fontSize: 12, opacity: 0.8 }}>
                Formato enviado: <strong>yyyy-mm-dd</strong>
              </div>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseReportModal} disabled={loadingReport}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={descargarReporteVentasExcel} disabled={loadingReport}>
              {loadingReport ? 'Generando...' : 'Generar Excel'}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal para editar la cantidad del producto */}
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Modificar Cantidad</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedProduct && (
              <>
                <h3>{selectedProduct.name}</h3>
                <p>{selectedProduct.description}</p>
                <p><strong>Cantidad actual:</strong> {newQuantity}</p>
                <Form>
                  <Form.Group controlId="cantidad">
                    <div className="quantity-controls">
                      {/* Campo para adición */}
                      <Form.Group controlId="addition" className="mt-2">
                        <Form.Label>Agregar:</Form.Label>
                        <Form.Control
                          type="number"
                          value={addition}
                          onChange={(e) => setAddition(e.target.value)}
                          min="0"
                        />
                      </Form.Group>

                      {/* Campo para sustracción */}
                      <Form.Group controlId="subtraction" className="mt-2">
                        <Form.Label>Eliminar:</Form.Label>
                        <Form.Control
                          type="number"
                          value={subtraction}
                          onChange={(e) => setSubtraction(e.target.value)}
                          min="0"
                        />
                      </Form.Group>

                      {/* Campo para sustracción */}
                      <Form.Group controlId="subtraction" className="mt-2">
                        <Form.Label>No. Documento:</Form.Label>
                        <Form.Control
                          type="text"
                          value={documento}
                          onChange={(e) => setDocumento(e.target.value)}
                        />
                      </Form.Group>

                      {/* Campo para sustracción */}
                      <Form.Group controlId="subtraction" className="mt-2">
                        <Form.Label>Proveedor:</Form.Label>
                        <Form.Control
                          type="text"
                          value={proveedor}
                          onChange={(e) => setProveedor(e.target.value)}
                        />
                      </Form.Group>
                    </div>
                  </Form.Group>
                </Form>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Cancelar
            </Button>
            {role === 1 || role === 2 ? (
              <Button variant="primary" onClick={handleSaveQuantity} disabled={savingQuantity}>
                {savingQuantity ? 'Guardando...' : 'Guardar Cambios'}
              </Button>
            ) : (
              <p>No tienes permiso para modificar este producto.</p>
            )}
          </Modal.Footer>
        </Modal>
        
        {/* Acciones para móviles (dropdown) */}
        <div className="mobile-actions">
          <Dropdown drop="up" align="end">
            <Dropdown.Toggle id="acciones-toggle" variant="success" className="mobile-actions-toggle">
              Acciones
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {role === 1 && (
                <Dropdown.Item onClick={handleUsuariosClick}>
                  Modificar Usuarios
                </Dropdown.Item>
              )}
              {role === 1 && (
                <Dropdown.Item onClick={handleProductosClick}>
                  Modificar Productos
                </Dropdown.Item>
              )}
              {(role === 1 || role === 2 || role === 3) && (
                <Dropdown.Item onClick={handleCreateOrder}>
                  Órdenes de Compra
                </Dropdown.Item>
              )}
              {(role === 1 || role === 2) && (
                <Dropdown.Item onClick={handleCreateShipment}>
                  Envíos
                </Dropdown.Item>
              )}
              {role === 1 && (
                <Dropdown.Item onClick={handleOpenReportModal}>
                  Reportes
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>


        {/* Botones en la parte inferior derecha */}
        <div className="buttons-container">
          {role === 1 ?(
            <Button variant="success" onClick={handleUsuariosClick} className="create-shipment-button">
                Modificar Usuarios
            </Button>
          ) : null}
          {role === 1 ?(
            <Button variant="success" onClick={handleProductosClick} className="create-shipment-button">
                Modificar Productos
            </Button>
          ) : null}
          {role === 1 || role === 2 || role === 3 ? (
            <Button variant="success" onClick={handleCreateOrder} className="create-shipment-button">
              Ordenes de Compra
            </Button>
          ) : null}
          {role === 1 || role === 2 ? (
            <Button variant="success" onClick={handleCreateShipment} className="create-shipment-button">
              Envíos
            </Button>
          ) : null}
          {role === 1 ? (
            <Button variant="success" onClick={handleOpenReportModal} className="create-shipment-button">
              Reportes
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Usuario;
